import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import NavigationReducer from './reducers/NavigationSlice'
import PagesReducer from './reducers/PagesSlice'
import QuotesReducer from './reducers/QuotesSlice'
import SkillReducer from './reducers/SkillSlice';
import SkillHierarchyReducer from './reducers/SkillHierarchySlice';
import ExperienceReducer from './reducers/ExperienceSlice';
import ProjectsReducer from './reducers/ProjectsSlice';
import CertificationsReducer from './reducers/CertificationsSlice';

const store = configureStore({
  reducer: {
    Skill: SkillReducer,
    SkillHierarchy: SkillHierarchyReducer,
    Experience: ExperienceReducer,
    Navigation: NavigationReducer,
    Pages: PagesReducer,
    Quotes: QuotesReducer,
    Projects: ProjectsReducer,
    Certifications: CertificationsReducer
  }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector

export default store